export default __webpack_public_path__ + "static/media/nonono.2321d22f.jpeg";